import { __assign } from 'tslib';
import React__default from 'react';
import { MenuItem, IconButton, Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../../DefaultIcon/index.js';

var FolderHeader = function (_a) {
    var parentFolder = _a.parentFolder, currentFolder = _a.currentFolder, onGoToParent = _a.onGoToParent, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b, _c = _a.testId, testId = _c === void 0 ? "FolderHeader" : _c, className = _a.className, _d = _a.id, id = _d === void 0 ? "FolderHeader" : _d, style = _a.style, sx = _a.sx;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(MenuItem, { className: clsx("FolderHeader", className), "data-testid": testId, id: id, style: style, sx: __assign({ minHeight: function (theme) { return theme.spacing(3.5); }, "& .MuiToolbar-root": {
                padding: function (theme) { return theme.spacing(0, 0.5, 0, 1.75); }
            } }, sx), onKeyDown: function (e) { return e.key === "Enter" && onGoToParent(e); } },
        React__default.createElement(IconButton, { "data-testid": "goToParent", id: "filter-folder-back-button", edge: "start", "aria-label": (parentFolder === null || parentFolder === void 0 ? void 0 : parentFolder.title)
                ? "".concat(t("filter.folder.return.to"), " \"").concat(parentFolder === null || parentFolder === void 0 ? void 0 : parentFolder.title, "\"")
                : "".concat(t("filter.folder.back.to.parent")), title: (parentFolder === null || parentFolder === void 0 ? void 0 : parentFolder.title)
                ? "".concat(t("filter.folder.return.to"), " \"").concat(parentFolder === null || parentFolder === void 0 ? void 0 : parentFolder.title, "\"")
                : "".concat(t("filter.folder.back.to.parent")), onClick: function (e) { return onGoToParent(e); } },
            React__default.createElement(KIcon, { className: "fa-solid fa-ellipsis", sx: {
                    fontSize: function (theme) { return theme.spacing(2); },
                    color: "rgba(0,0,0,0.6)",
                    width: function (theme) { return theme.spacing(1.25); },
                    height: function (theme) { return theme.spacing(1.25); },
                    translate: "-2px 0"
                } })),
        React__default.createElement(KIcon, { className: "fa-solid fa-slash-forward", sx: {
                fontSize: function (theme) { return theme.spacing(1.75); },
                width: "inherit",
                color: "rgba(0,0,0,0.6)",
                translate: "-2px 0"
            } }),
        React__default.createElement(Box, { sx: { maxWidth: "calc(100% - 10px)" } },
            React__default.createElement(Typography, { color: "inherit", component: "div", sx: {
                    fontSize: "0.875rem",
                    cursor: "default",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                }, title: currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.title }, currentFolder === null || currentFolder === void 0 ? void 0 : currentFolder.title))));
};

export { FolderHeader as default };
//# sourceMappingURL=index.js.map
